import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import styles from "./calendar.module.css";

import { Popover, Typography } from 'antd';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
import { GoPrimitiveDot } from "react-icons/go";
import { AntdSubmit } from '../../../components';
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../../components/submitButton/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import ScheduleMiddleware from "../../../store/Middlewares/ScheduleMiddleware";


const localizer = momentLocalizer(moment);


function RBCToolbar(props) {
    const { label, date, view, views, onView, onNavigate } = props;
    const [month, setMonth] = useState("January");
    const mMonth = moment(date).format("MMM");
    const months = moment.months();

    useEffect(() => {
        setMonth(mMonth);
    }, [mMonth]);


    const onChange = (event) => {
        const current = event.target.value;
        onNavigate("DATE", moment().month(current).toDate());
        setMonth(current);
    };

    const goToView = (view) => {
        onView(view);
    };

    const goToBack = () => {
        onNavigate("PREV");
    };
    const goToNext = () => {
        onNavigate("NEXT");
    };

    const goToToday = () => {
        onNavigate("TODAY");
    };

    return (
        <div className="rbc-toolbar">
            <div className={`${styles.main_Cont}`}>

                <div onClick={goToBack} className={styles.flexClass}>
                    <div>
                        <BiLeftArrowAlt size={22} />
                    </div>
                    <div>
                        <h1 >{moment(date).add(-1, 'months').format("MMM")}</h1>
                    </div>

                </div>
                <div>
                    <h1>{mMonth} {moment(date).format('YYYY')}</h1>
                </div>
                <div onClick={goToNext} className={styles.flexClass}>
                    <div>
                        <h1>{moment(date).add(1, 'months').format("MMM")}</h1>
                    </div>
                    <div>
                        <BiRightArrowAlt size={22} />
                    </div>
                </div>
            </div>
        </div>
    );
}


function Event(event) {
    const { Text } = Typography;
    const item = event.event?.itemData
    console.log('data event ]]]]]]]]]]]', event);


    const content = (
        <div className={styles.eventTooltipMainCont}>
            <div className={styles.eventTooltipDate}>
                <div>
                    <Text style={{ color: 'white',fontSize:20,fontWeight:'bold' }}>{moment(item?.date).format('Do')}</Text>
                </div>
                <div>
                    <Text style={{ color: 'white' }}>{moment(item?.date).format('dddd')}</Text>
                </div>
            </div>
            <div style={{padding:'5px',width:'100%'}}>
                <div>
                    <Text style={{ color: 'white' }}>{item?.cleaner_name}</Text>
                </div>
                <div>
                    <Text style={{ color: 'white' }}>{
                        // data?.start_time + ' To ' + data?.end_time
                        moment('01 jan 1940 ' + item?.start_time).format('LT') + ' To ' + moment('01 jan 1940 ' + item?.end_time).format('LT')
                    }</Text>
                </div>
                <div>
                    <Text style={{ color: 'white' }}>{item?.location?.state}</Text>
                </div>
                <div>
                    <Text style={{ color: 'white' }}>{item?.location?.address}</Text>
                </div>

            </div>
        </div>
    );
    return (
        <>

            <Popover placement="bottom" content={content} style={{ backgroundColor: 'transparent', width: '200px' }}>
                <div className={styles.eventCont}>
                    <div>
                        <GoPrimitiveDot className={styles.iconClass} size={25} />
                    </div>
                </div>
            </Popover>
        </>
    );
}


function CalendarSchedule() {

    const navigate = useNavigate();
    useEffect(() => {
        onSelectDate(moment().format())
        getLanguage();
    }, []);

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language);
        } catch (e) {
            console.log(e);
        }
    };

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const timeout = useRef(null);

    const user = useSelector(state => state.AuthReducer.user);

    const [data, setData] = useState([]);

    const onSelectDate = date => {
        let data = {
            // date: moment(date).format('YYYY-MM-DD'),
        };

        dispatch(ScheduleMiddleware.getSpecificSchedule(data))
            .then(data => {
                setData(data?.data?.data);
            })
            .catch(e => {
                console.log('error', e);
            });
    };

    const eventsData = data?.map((data) => {
        let startDate = data.date
        return {
            itemData: data,
            title: data?.details,
            start: new Date(startDate),
            end: new Date(startDate),
            color: 'red',
        };
    });
    console.log("eventsData", eventsData);

    return (
        <div className={styles.home_mainContainer}>
            <div className={styles.flexClass} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <h1 className={styles.heading}>{t("Calendar")}</h1>
                </div>
                <div>
                    <AntdSubmit text={'View Schedule'}
                        buttonStyle={{ width: '100%', height: '50px' }}
                        onClick={() => {
                            navigate('/schedule/Calendar/Schedules')
                        }} />
                </div>
            </div>
            <div className="tab_content_styling">
                <Calendar
                    step={30}
                    //   toolbar={true}
                    style={{ width: "100%", height: 500, marginBottom: "20px", color: 'white', backgroundColor: 'transparent' }}
                    tooltipAccessor={true}
                    localizer={localizer}
                    events={eventsData}
                    onSelectEvent={(data) => {
                        // handleShow();
                        // setSchedule(data?.data);
                    }}
                    //   step={60}
                    components={{
                        toolbar: RBCToolbar,
                        dateCellWrapper: (props) => <div className={styles.dayCell}></div>,
                        event: Event,
                        resourceHeader: (props) => <div className={styles.dayCell} style={{ border: 0 }}></div>,
                        // event: () => {
                        //     return (

                        //         <Tooltip placement="top" title='hello'>
                        //             <div className={styles.eventCont}>
                        //                 <div>
                        //                     <GoPrimitiveDot className={styles.iconClass} size={25} />
                        //                 </div>
                        //             </div>

                        //         </Tooltip>
                        //     )
                        // }

                    }}
                    //   defaultDate={new Date()}
                    views={{
                        month: true,
                        week: false,
                    }}
                    //   onDrillDown={(newDate) => {
                    //     setClick(newDate);
                    //     setDate(newDate);
                    //     filterHandler(stafId, roomId, newDate, childId);
                    //     console.log("calendar data", date);
                    //   }}
                    eventPropGetter={(eventsData) => {
                        return { style: { backgroundColor: 'transparent', outline: 0, } };

                    }}

                // min={new Date(2008, 0, 1, 8, 0)} // 8.00 AM
                // max={new Date(2008, 0, 1, 17, 0)} // Max will be 6.00 PM!
                //   date={new Date()}
                />
            </div>
        </div>
    );
}



export default CalendarSchedule